import NetworkProvider from '../Provider';

const url = '/api/v1/verify/line';

const verifyWithLine = async (code) => {
  const payload = {
    code,
  };
  return NetworkProvider().post(url, payload);
};

export default verifyWithLine;